function toggleForms(){
  $('.forgotten-password').on('click', function(e) {
    e.preventDefault();
    $(this).closest('form').hide().next('form').show();
  })

  $('.link-forgot-password a').on('click', function(e) {
    e.preventDefault();
    $(this).closest('form').hide().prev('form').show();
  })

  if (window.location.hash == '#recover' && $('body').hasClass('template-customers-login')) {
    $('.form-recover-password').show().prev('form').hide();
  }
}

export default toggleForms();



// WEBPACK FOOTER //
// ../markup/assets/js/account-forgotten-password.js